import { render, staticRenderFns } from "./base-datatable.vue?vue&type=template&id=cdd9e102"
import script from "./base-datatable.vue?vue&type=script&lang=js"
export * from "./base-datatable.vue?vue&type=script&lang=js"
import style0 from "./base-datatable.vue?vue&type=style&index=0&id=cdd9e102&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports